import { ThemeOptions } from '@mui/material/styles';

export const mwgColors = {
  primary: '#003087',
  primaryShade: '#002a77',
  primaryTint: '#1a4593',
  primaryContrast: '#ffffff',
  backgroundContent: '#f5f6f7',
} as const;

const mwgThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: mwgColors.primary,
      dark: mwgColors.primaryShade,
      light: mwgColors.primaryTint,
      contrastText: mwgColors.primaryContrast,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '16px',
          overflow: 'hidden',
          position: 'relative' as const,
          paddingBottom: '4px',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '4px',
            background:
              'linear-gradient(to right, #e31b23, #a11a5e, #5b2d8e, #1b3fa0, #0a2f9a)',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: mwgColors.primary,
          '&:focus': {
            color: mwgColors.primaryShade,
            outline: `solid 2px ${mwgColors.primaryShade}`,
          },
          '&:hover': {
            color: mwgColors.primaryShade,
          },
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            backgroundColor: mwgColors.primary,
            '&:focus': {
              border: `1px solid ${mwgColors.primaryShade}`,
              backgroundColor: mwgColors.primaryShade,
              outline: `solid 2px ${mwgColors.primaryShade}`,
              outlineOffset: '1px',
            },
            '&:hover': {
              backgroundColor: mwgColors.primaryShade,
            },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            '&:focus': {
              color: mwgColors.primaryShade,
              outline: `solid 2px ${mwgColors.primaryShade}`,
              outlineOffset: '1px',
            },
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '.MuiSwitch-switchBase.Mui-checked:hover': {
            backgroundColor: `${mwgColors.primary}1A`,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:focus': {
            outline: `solid 2px ${mwgColors.primaryShade}`,
          },
        },
      },
    },
  },
};

export default mwgThemeOptions;
